module.exports = __webpack_public_path__ + "img/oddnary-variation-6.a93c34ba.jpg";